import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import {
  leadersOverview as leadersOverviewApi
} from 'redux/modules/api'
import { setPage, notification, modal, logError } from 'redux/modules/app'
import mapLeadersOverviewForBulk from '../../../../redux/selectors/leadersOverview/mapLeadersOverviewForBulk'
import areAllSelectedForBulk from '../../../../redux/selectors/leadersOverview/areAllSelectedForBulk'
import uuid from 'uuid'
import { toggleLeadersOverviewAllSelected } from '../../../../redux/modules/api/leadersOverview'


function decorator(config = {}) {
  return ComposedComponent => {
    // leaders: api.organizations.leaders,
    const enhance = compose(
      withRouter,
      connect(state => ({
          leadersOverview: state.api.leadersOverview,
          commonLimit: state.app.commonLimit,
          user: state.auth.user,
          activeOrganizationId: state.auth.organization.id,
          selectableLeaderIds: config.list ? mapLeadersOverviewForBulk(state) : [],
          areAllLeadersSelected: config.list ? areAllSelectedForBulk(state) : false
        }),
        {
          ...leadersOverviewApi,
          setPage,
          modal,
          push,
          notification,
          logError,
          bulkSelectLeaders: leadersOverviewApi.toggleLeadersOverviewAllSelected
        }
      )
    )

    class Leaders extends Component {
      static propTypes = {
        user: PropTypes.object.isRequired,
        activeOrganizationId: PropTypes.number.isRequired,
        decoUpdateOrganizationOverview: PropTypes.bool,
        local: PropTypes.object.isRequired,
        leaders: PropTypes.object.isRequired,
        params: PropTypes.object,
        decoOrganizationId: PropTypes.number,
        getLeader: PropTypes.func.isRequired,
        getLeaders: PropTypes.func.isRequired,
        getLeadersForSearch: PropTypes.func.isRequired,
        transferLeaderParticipants: PropTypes.func.isRequired,
        uploadPersonImage: PropTypes.func.isRequired,
        deletePersonImage: PropTypes.func.isRequired,
        findLeader: PropTypes.func.isRequired,
        updateLeader: PropTypes.func.isRequired,
        addTraining: PropTypes.func.isRequired,
        updateTraining: PropTypes.func.isRequired,
        deleteTraining: PropTypes.func.isRequired,
        sendConfirmationEmail: PropTypes.func.isRequired,
        deleteOrganizationContact: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        moveLeader: PropTypes.func.isRequired,
        getProfile: PropTypes.func.isRequired,
        addHistoryRecord: PropTypes.func.isRequired,
        updateHistoryRecord: PropTypes.func.isRequired,
        deleteHistoryRecord: PropTypes.func.isRequired,
        exportLeaders: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        approveAwardLeader: PropTypes.func.isRequired,
        hocShouldUpdatePersonDetail: PropTypes.bool,
        getTasksRegistrationAwardLeaders: PropTypes.func.isRequired,
        commonLimit: PropTypes.number,
        setLeadersParams: PropTypes.func,
        resetLeaderDetail: PropTypes.func.isRequired,
        selectableLeaderIds: PropTypes.list,
        areAllLeadersOverviewSelected: PropTypes.list,
        setLeadersOverviewSelected: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      constructor(props) {
        super(props)
        this.key = uuid.v1()
      }


      componentDidMount() {
        const { commonLimit, setLeadersOverviewParams, leadersOverview } = this.props

        if (config.useCommonLimit && commonLimit) {
          setLeadersOverviewParams({ limit: commonLimit })
        }
        else {
          config.list &&
          this.handleGetLeadersOverview(leadersOverview)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { leadersOverview } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.leadersOverview

        if (
          leadersOverview.filter !== filter ||
          leadersOverview.limit !== limit ||
          leadersOverview.offset !== offset ||
          leadersOverview.sort !== sort ||
          leadersOverview.invalidate !== invalidate
        ) {

          const reloadCount =
            leadersOverview.filter !== filter || leadersOverview.invalidate !== invalidate

          config.list &&
          this.handleGetLeadersOverview(nextProps.leadersOverview, reloadCount)
        }
      }


      handleGetLeadersOverview = (leadersOverview, reloadCount) => {
        this.props
          .getLeadersOverview(leadersOverview)
          .catch(this.handleError)

        reloadCount && this.props
          .getLeadersOverviewCount(leadersOverview)
          .catch(this.handleError)
      }


      handleError = err => {
        console.log('error', err.body && err.body.bodyMessage)
        this.props.logError(err)
      }


      handleSetLeaderSelectedTo = (id, newVal) => {
        const ids = this.props.leadersOverview.selectedIds || []
        const newIds = ids.filter(i => i !== id).concat(newVal ? [id] : [])

        this.props.setLeadersOverviewSelected(newIds)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            key={this.key}
            setLeaderSelectedTo={this.handleSetLeaderSelectedTo}
          />
        )
      }
    }

    return enhance(Leaders)
  }
}

export default decorator
